import { pathOr } from 'ramda';
import { useBetsSelector } from '../../store';

export const selectMultiSystemDetails = (cardId) =>
  pathOr({}, ['multiSystemDetails', cardId]);

export const useMultiSystemDetails = (cardId) =>
  useBetsSelector(selectMultiSystemDetails, [cardId]);
